import type { LevelDef } from '../sim/level/schema';

export const OFFICE_LEVEL_ID = 'office-overtime';

/**
 * A continuous floor and three desks give every fighter a route above and below the action.
 * Furniture legs, screens and office clutter are scenery: only the tabletops collide, so bodies
 * cannot wedge bots between a desk leg and a filing cabinet.
 */
export const officeOvertime: LevelDef = {
  id: OFFICE_LEVEL_ID,
  name: 'Overtime',
  theme: 'office',
  bounds: { x: 0, y: 0, w: 36, h: 16 },
  killMargin: 6,
  spawns: [
    { x: 3, y: 3.5 },
    { x: 33, y: 3.5 },
    { x: 7, y: 6.1 },
    { x: 29, y: 6.1 },
    { x: 12, y: 3.5 },
    { x: 24, y: 3.5 },
    { x: 16, y: 6.1 },
    { x: 20, y: 6.1 },
  ],
  drops: { enabled: true, xMin: 3, xMax: 33, intervalScale: 0.85 },
  objects: [
    { type: 'solid', x: 18, y: 1, w: 36, h: 2 },
    { type: 'solid', x: 7, y: 4.4, w: 6, h: 0.4 },
    { type: 'solid', x: 18, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 29, y: 4.4, w: 6, h: 0.4 },
  ],
  decor: [
    { kind: 'office-wall', x: 18, y: 2 },
    { kind: 'office-window', x: 7, y: 9.9 },
    { kind: 'office-window', x: 29, y: 9.9 },
    { kind: 'office-whiteboard', x: 18, y: 10.3 },
    { kind: 'office-clock', x: 18, y: 13.9, scale: 0.8 },
    { kind: 'office-light', x: 7, y: 14.7 },
    { kind: 'office-light', x: 18, y: 14.7 },
    { kind: 'office-light', x: 29, y: 14.7 },
    { kind: 'office-desk', x: 7, y: 2 },
    { kind: 'office-desk', x: 29, y: 2 },
    { kind: 'office-conference', x: 18, y: 2 },
    { kind: 'office-monitor', x: 6.3, y: 4.6 },
    { kind: 'office-monitor', x: 29.7, y: 4.6 },
    { kind: 'office-papers', x: 8.8, y: 4.6 },
    { kind: 'office-papers', x: 27.2, y: 4.6 },
    { kind: 'office-plant', x: 1.5, y: 2 },
    { kind: 'office-plant', x: 34.5, y: 2 },
  ],
};
